module.exports = __webpack_public_path__ + "images/marketing/google-partner2.png";